import { Text } from "components/core/Text";
import { GoogleLoginButton } from "components/core/buttons/GoogleLoginButton";
import { IconButton } from "components/core/buttons/IconButton";
import { KakaoLoginButton } from "components/core/buttons/KakaoLoginButton";
import isWebview from "is-ua-webview";
import { ComponentProps, useMemo } from "react";

import { MixModal } from "./MixModal";

type SignInModalProps = ComponentProps<typeof MixModal> & {
    close: () => Promise<void>;
};

export const SignInModal = ({ close, ...props }: SignInModalProps) => {
    return (
        <MixModal {...props}>
            <Default close={close} />
        </MixModal>
    );
};

function Default({ close }: Pick<SignInModalProps, "close">) {
    const webview = useMemo(() => isWebview(navigator.userAgent), []);

    return (
        <div className="flex w-[342px] flex-col rounded-2xl bg-grey-a100 px-4 pb-24 pt-4 md:w-[600px] md:pb-12">
            <div className="mb-2 flex justify-end">
                <IconButton
                    name="Close"
                    variant="background"
                    color="grey"
                    size="large"
                    onClick={close}
                />
            </div>
            <div className="flex flex-col items-center gap-10">
                <header className="flex flex-col gap-2 break-keep text-center">
                    <Text
                        className="block min-w-[311px] text-common-black-main dark:text-common-white-main md:hidden"
                        variant="h2"
                    >
                        믹스에 오신것을 환영합니다!
                    </Text>
                    <Text
                        className="hidden text-common-black-main dark:text-common-white-main md:block"
                        variant="h2"
                    >{`믹스에 오신것을\n환영합니다!`}</Text>
                    <Text
                        className="md:text-sm md:font-normal md:leading-[139.9999976158142%]"
                        variant="body1"
                        color="text.disabled"
                    >
                        믹스가 엄선한 마케팅 콘텐츠를 경험해보세요.
                    </Text>
                </header>
                <div className="flex flex-col items-center gap-6">
                    <div className="flex w-[250px] flex-col gap-3 md:w-[300px]">
                        {!webview && <GoogleLoginButton onSuccess={close} />}
                        <KakaoLoginButton />
                    </div>
                    <Text
                        className="w-[250px] break-keep text-center text-text-placeholder md:w-[350px] [&_a]:underline"
                        variant="caption2"
                        tag="p"
                    >
                        {"로그인은 "}
                        <a
                            href="https://support.mix.day/e8ceb0d6-cba8-496f-873f-19e657abe168"
                            target="_blank"
                            rel="noreferrer"
                        >
                            개인정보 보호정책
                        </a>
                        {" 및 "}
                        <a
                            href="https://support.mix.day/7892acb6-7072-477d-abc1-224fe83fb855"
                            target="_blank"
                            rel="noreferrer"
                        >
                            서비스 약관
                        </a>
                        에 동의하는 것을 의미하며 서비스 이용을 위해 이메일과
                        이름, 프로필 이미지를 수집합니다.
                    </Text>
                </div>
            </div>
        </div>
    );
}
